module.exports = __webpack_public_path__ + "img/i-default.241325ac.svg";